import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import ImageDesktop from 'assets/illustrations/saved-searches-empty-state-d.svg'
import ImageMobile from 'assets/illustrations/saved-searches-empty-state-m.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const NoFiled = () => {
  const t = useTranslation()
  const classes = useStyles()

  return (
    <Box my={3} display="flex" flexDirection="column" alignItems="center">
      <Typography variant="h2" gutterBottom className={classes.title}>
        {t('error:no-filed-title')}{' '}
        <span role="img" aria-label="search">
          🔍
        </span>
      </Typography>
      <Box mb={3} maxWidth={440} textAlign="center">
        <Typography variant="subtitle1" color="textSecondary">
          {t('error:no-filed-subtitle')}
        </Typography>
      </Box>
      <Hidden smUp>
        <img src={ImageMobile} alt="" className={classes.image} />
      </Hidden>
      <Hidden xsDown>
        <img src={ImageDesktop} alt="" className={classes.image} />
      </Hidden>
    </Box>
  )
}

export default NoFiled
